jQuery.each jQuery("script[id$='-partial']"), (i, v) ->
	name = jQuery(@).attr 'id'
	name = name.replace '-partial', ''
	Handlebars.registerPartial name, jQuery(@).html()

Handlebars.registerHelper "modal", (options) ->
	return options.data.root.modal+'-modal'

Handlebars.registerHelper "switch", (value, options) ->
	this._switch_value_ = value
	html = options.fn this
	delete this._switch_value_
	return html

Handlebars.registerHelper "case", () ->
	# if value == this._switch_value_
	# 	return options.fn this

	args = Array.prototype.slice.call arguments
	options = args.pop()
	caseValues = args

	if caseValues.indexOf(this._switch_value_) is -1
		return ''
	else
		return options.fn this

Handlebars.registerHelper "sanitize", (value = '', options) ->
	return value.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'')

Handlebars.registerHelper "var", (name, value, options) ->
	options.data.root[name] = value
	return null

Handlebars.registerHelper "suffix", (value = '', suffix = '', options) ->
	return value+suffix

Handlebars.registerHelper "ifel", (variable, value, istrue, isfalse, options) ->
	if variable is value
		return istrue
	else
		return isfalse

Handlebars.registerHelper "empty", (variable, options) ->
	if variable is undefined or variable is null or variable is '' or variable is false
		return true
	else
		return false

Handlebars.registerHelper "ucfirst", (variable, options) ->
	return variable.charAt(0).toUpperCase()+variable.slice 1

Handlebars.registerHelper "titlecase", (variable, options) ->
	variable = variable.replace /_/g, ' '
	return variable.replace /(?:^|\s)\w/g, (match) ->
		return match.toUpperCase()

Handlebars.registerHelper "pluralize", (variable, single, plural, options) ->
	if variable is '1'
		return single
	else
		return plural

Handlebars.registerHelper "parseInt", (variable, options) ->
	return parseInt variable

Handlebars.registerHelper "typeof", (variable, options) ->
	return typeof variable

Handlebars.registerHelper "replace", (string, find, replace, options) ->
	return string.replace find, replace

Handlebars.registerHelper "math", (variable, operator, operand, options) ->
	variable = parseFloat variable
	operand = parseFloat operand
		
	return {
		"+": variable + operand
		"-": variable - operand
		"*": variable * operand
		"/": variable / operand
		"%": variable % operand
	}[operator]

Handlebars.registerHelper "compare", (variable, comparator, operand, options) ->
	variable = parseFloat variable
	operand = parseFloat operand
		
	return {
		"==": variable == operand
		"!=": variable != operand
		">": variable > operand
		"<": variable < operand
		">=": variable >= operand
		"<=": variable <= operand
	}[comparator]

Handlebars.registerHelper "typeof", (variable, options) ->
	return typeof variable

Handlebars.registerHelper "ifnot", (variable, value, options) ->
	if variable isnt value
		options.fn this
	else
		options.inverse this

Handlebars.registerHelper "ifval", (variable, value, options) ->
	if variable is value
		options.fn this
	else
		options.inverse this

Handlebars.registerHelper "join", () ->
	args = Array.prototype.slice.call arguments
	separator = args[0]
	args.shift()
	options = args.pop()

	return args.join separator

Handlebars.registerHelper 'json', (context) ->
	return JSON.stringify context